var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message-list"},_vm._l((_vm.messageGroups),function(messageGroup){return _c('message-group',{key:'gr_' + messageGroup.id,attrs:{"message-group":messageGroup}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }